// src/services/toast.js
import { createToastInterface } from 'vue-toastification'
import 'vue-toastification/dist/index.css'
import toastOptions from '@/utils/toastConfig' // Adjust the path as necessary

const toast = createToastInterface(toastOptions)

export default toast
